import React from "react";
import Alert from 'react-bootstrap/Alert';

class AlertComponent extends React.Component {

    static defaultProps = {
        idx: Math.random(),
        variant: 'primary',
        message: '',
        show: false
    };

    render() {
        let {idx, variant, message, show, dismissFunc} = this.props;

        if (!show) {
            return null;
        }

        return (
            <Alert key={idx} variant={variant}  onClose={dismissFunc} dismissible>
                {message}
            </Alert>
        );
    }
}

export default AlertComponent;



